import {connect} from "react-redux"
import {createSelector} from "reselect"
import State from "../../../models/State"
import TrackSortOption from "../../../events/trackEvent/events/trackSortOption"
import {setSelectedSortingAction} from "../../../ducks/search"

const selectSorting = (state: State) => state.search.sorting
const selectSiteUrl = (state: State) => state.request.siteUrl

export const selectSortingAndUrl = createSelector([selectSorting, selectSiteUrl], (sorting, siteUrl) => {
    const {selected, options} = sorting
    return {
        selected,
        options,
        siteUrl,
    }
})

export const mapStateToProps = (state: State) => {
    return {...selectSortingAndUrl(state)}
}

export const mapDispatchToProps = (dispatch: any) => ({
    setSelectedSort: (newValue: string) => {
        TrackSortOption(newValue)
        dispatch(setSelectedSortingAction(newValue))
    },
})

export default connect(mapStateToProps, mapDispatchToProps)
